export { default as ArchiveBoxXMark } from './ArchiveBoxXMark';
